/**
 * Reusable keyframe animations for AI components
 * All animations used across AI features are defined here
 */

import { keyframes } from '@mui/material';

export const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const waveAnimation = keyframes`
  0%, 100% {
    height: 20px;
  }
  50% {
    height: 60px;
  }
`;

export const dotAnimation = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export const shimmerAnimation = keyframes`
  0% {
    left: '-100%';
  }
  100% {
    left: '100%';
  }
`;

export const glowAnimation = keyframes`
  0% {
    filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.3));
  }
  100% {
    filter: drop-shadow(0 2px 8px rgba(102, 126, 234, 0.6)) drop-shadow(0 0 12px rgba(102, 126, 234, 0.4));
  }
`;

export const gradientShiftAnimation = keyframes`
  0%, 100% {
    backgroundPosition: '0% 50%';
  }
  50% {
    backgroundPosition: '100% 50%';
  }
`;

export const recordingPulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
`;
